import { call, put, select } from 'redux-saga/effects';

import * as InsuranceAnketaDataProviders from 'data-providers/insuranceAnketa';
import * as InsuranceAnketaActions from 'store/insuranceAnketa/actions';
import * as InsuranceAnketaConstants from 'store/insuranceAnketa/constants';
import { frontToBackCustomer } from 'store/insuranceAnketa/frontToBackMapper';
import * as InsuranceAnketaSelectors from 'store/insuranceAnketa/selectors';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import * as InsuranceConstants from '../../constants';
import * as InsuranceHelpers from '../../helpers';

export const insuranceStageUpdateInsurerCustomer = new InsuranceHelpers.CreateStage({
  action: InsuranceConstants.ACTIONS.UPDATE_INSURER_CUSTOMER,
  handler: function* () {
    const applicationId = yield select(InsuranceCalculationSelectors.selectApplicationId);
    const {
      [InsuranceAnketaConstants.FIELDS.CUSTOMER_ROLES]: roles,
      [InsuranceAnketaConstants.FIELDS.FILLED_CUSTOMERS]: customers,
      [InsuranceAnketaConstants.FIELDS.KASKO_INSURER_IS_DRIVER]: insurerIsDriver,
      [InsuranceAnketaConstants.FIELDS.OWNER_IS_INSURER]: ownerIsInsurer,
    } = yield select(InsuranceAnketaSelectors.selectInsuranceAnketa);

    const state = yield select(InsuranceAnketaSelectors.selectKaskoInsurer);
    let { [InsuranceAnketaConstants.FIELDS.ID]: customerId } = state;

    const isDefaultCustomerId = customerId === InsuranceAnketaConstants.DEFAULT_CUSTOMER_ID;

    // Бэк ничего не знает о страхователе
    if (ownerIsInsurer && isDefaultCustomerId) {
      yield put(InsuranceAnketaActions.resetInsurer());

      return;
    }

    if (!applicationId) {
      InsuranceHelpers.CreateStage.throwError({ message: 'Application ID is missing' });
    }

    const customersClone = structuredClone(customers);

    // Сначала нужно создать страхователя, а затем обновлять его данные
    if (!ownerIsInsurer && isDefaultCustomerId) {
      const { customer } = yield call(InsuranceAnketaDataProviders.newCustomer, {
        applicationId,
        role: InsuranceAnketaConstants.CUSTOMER_ROLES.INSURER,
      });

      customerId = customer.id;
      customersClone.push(customer);

      const role = {
        customerId: String(customerId),
        id: null,
        roleSysName: InsuranceAnketaConstants.CUSTOMER_ROLES.INSURER,
      };

      yield put(
        InsuranceAnketaActions.setBatchState({
          [InsuranceAnketaConstants.FIELDS.CUSTOMER_ROLES]: [...roles, role],
        })
      );
    }

    const customer = customersClone.find(({ id }) => {
      return id === customerId;
    });
    const customerClone = structuredClone(customer);

    if (!customer) {
      InsuranceHelpers.CreateStage.throwError({ message: 'The customer was not found' });
    }

    yield* InsuranceHelpers.customerRoleManaging({
      afterDelete: () => {
        InsuranceHelpers.dropDriverLicense({ customer: customerClone });
      },
      customerId,
      feature: insurerIsDriver,
      role: InsuranceAnketaConstants.CUSTOMER_ROLES.DRIVER,
    });
    yield* InsuranceHelpers.customerRoleManaging({
      customerId,
      feature: !ownerIsInsurer,
      role: InsuranceAnketaConstants.CUSTOMER_ROLES.INSURER,
    });

    if (ownerIsInsurer) {
      return;
    }

    // Обновляем данные, только если владелец не является страхователем
    yield call(
      InsuranceAnketaDataProviders.patchCustomer,
      frontToBackCustomer(structuredClone(state), customerClone)
    );
  },
  name: InsuranceConstants.STAGES_FIELDS.UPDATE_INSURER_CUSTOMER,
}).watcher;
